import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Topbar from "../Topbar/Topbar";
import { MdEdit } from "react-icons/md";
import { MdOutlineAssignmentInd } from "react-icons/md";
import "./Recoverystyle.css";
import RecoveryDetails from "./RecoveryDetails";
import WorkDetails from "./WorkDetails";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import MessageBox from "../MessageBox/MessageBox";

const ViewRecovery = () => {
  //message
const [pageRefId, setpageRefId] = useState("")
const [messageData, setMessageData] = useState([]);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const Id = useSelector((state) => state.id);
  const staffName = useSelector((state) => state.staffname);
  const location = useLocation();
  const customerId = location.state?.customerid;
const payloadItems=location.state
console.log(payloadItems)
  // Initialize activeTab from location.state or default to "recoverydetails"
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || "orderDetails");
  const [isOpenAssign, setIsOpenAssign] = useState(false);
  const [recoveryData, setRecoveryData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [originalData, setOriginalData] = useState(null);
  const [currentDate] = useState(new Date().toISOString().slice(0, 10));
  const [staffData, setStaffData] = useState([]);
   const [staffNameFetch, setStaffNameFetch] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState([]);
  const [isStaffDropdownOpen, setIsStaffDropdownOpen] = useState(false);
  const [isApproverDropdownOpen, setIsApproverDropdownOpen] = useState(false);
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
  
  const [coordinates, setCoordinates] = useState([0, 0]);
  const hideButtons = location.state?.hideButtons === true || location.state?.hideButtons=== "true";
  const taskId= location.state?.taskId// Get taskid from location.state or set to null if not available
  console.log(taskId);
  
  console.log(hideButtons, "hideButtons value from state");
  const staffDropdownRef = useRef(null);
  const approverDropdownRef = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();
 const page = "recovery"; // static page value


  const [taskData, setTaskData] = useState({
    taskName: "Recovery",
    assignedBy: staffName,
    assignDateTime: new Date().toISOString().slice(0, 16),
    taskType: "Once",
    taskPriority: "Low",
    deadline: "",
    time: "",
    assignedTo: [],
    approvePerson: null,
    description: "",
    leadId: id,
    name: "",
    taskStatus: "Open",
  });
  //active tab useeffect
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);
  // Fetch recovery data
  useEffect(() => {
    console.log("useEffect triggered with id:", location.state?.id);

    const fetchRecoveryData = async () => {
      try {
        const response = await axios.get(apiUrl + "recovery-get", {
          params: { id: location.state?.id },
        });

        console.log("API Response:", response.data);
        setRecoveryData(response.data);
         setpageRefId(response.data._id)
      } catch (error) {
        console.error("Error fetching recovery data:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load recovery data",
        });
      }
    };

    if (location.state?.id) {
      fetchRecoveryData();
    } else {
      console.error("No ID found in location.state");
    }
  }, [location.state?.id, apiUrl]);

  // Fetch staff data
  useEffect(() => {
    axios
      .get(apiUrl + "get-staff-names")
      .then((res) => {
        if (res.data.message) {
          setStaffNameFetch(res.data.message);
        }
      })
      .catch((err) => {
        console.log("Error fetching staff names:", err);
      });
  }, []);

  // Fetch staff whole data for dropdown
    useEffect(() => {
      axios
        .post(
          apiUrl + "viewstaff",
  
          {}
        )
        .then((res) => {
          setStaffData(res.data.message);
  
          console.log(res.data.message);
         
        });
    }, [apiUrl]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        staffDropdownRef.current &&
        !staffDropdownRef.current.contains(event.target)
      ) {
        setIsStaffDropdownOpen(false);
      }
      if (
        approverDropdownRef.current &&
        !approverDropdownRef.current.contains(event.target)
      ) {
        setIsApproverDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOpenAssign = () => {
    setIsOpenAssign(!isOpenAssign);
  };

  const handleEditClick = () => {
    setOriginalData(JSON.parse(JSON.stringify(recoveryData)));
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    if (originalData) {
      setRecoveryData(JSON.parse(JSON.stringify(originalData)));
      // Reset coordinates if they were changed
      if (originalData?.location?.coordinates) {
        setCoordinates(originalData.location.coordinates);
      }
    }
    setIsEditing(false);
  };

// const handleSaveClick = async () => {
//   try {
//     if (!recoveryData?.customerid) {
//       Swal.fire({ icon: "error", title: "Error", text: "Customer ID is missing!" });
//       return;
//     }

//     const { _id, ...dataToUpdate } = recoveryData;

//     // Format location
//     if (dataToUpdate.location && Array.isArray(dataToUpdate.location.coordinates)) {
//       dataToUpdate.location = {
//         type: "Point",
//         coordinates: dataToUpdate.location.coordinates
//       };
//     }

//     const now = new Date();
//     const date = now.toLocaleDateString();
//     const time = now.toLocaleTimeString();

//     // 1️⃣ ALWAYS UPDATE RECOVERY DATA
//     console.log("Updating recovery data...");
//     const recoveryResponse = await axios.put(
//       `${apiUrl}recovery-update/${recoveryData.customerid}`,
//       dataToUpdate
//     );
//     console.log("Recovery update success:", recoveryResponse.data);

//     // 2️⃣ CONDITIONALLY UPDATE TASK STATUS (Only in Task Completion Flow)
//     if (!isEditing && taskId) {
//       console.log("Updating task status to Completed...");
//       await axios.put(
//         `${apiUrl}update-task`,
//         {
//           id: taskId,
//           updateData: {
//             taskStatus: "Completed",
//             taskUpdatedBy: {
//               staffName,
//               _id: Id,
//               time,
//               date
//             }
//           }
//         },
//         {
//           headers: { "Content-Type": "application/json" }
//         }
//       );
//       console.log("Task status updated successfully");
//     }

//     // Success handling
//     Swal.fire({ 
//       title: "Success!", 
//       text: isEditing ? "Recovery updated" : "Task completed & recovery updated",
//       icon: "success" 
//     });

//     setIsEditing(false);

//   } catch (error) {
//     console.error("Update failed:", error);
//     Swal.fire({
//       icon: "error",
//       title: "Error",
//       text: error.response?.data?.message || "Update operation failed",
//     });
//   }
// };
const handleSaveClick = async () => {
  try {
    // Validate required data
    if (!recoveryData?.customerid) {
      Swal.fire({ icon: "error", title: "Error", text: "Customer ID is missing!" });
      return;
    }

    // Prepare recovery data
    const { _id, ...dataToUpdate } = recoveryData;
    
    // Format location data if exists
    if (dataToUpdate.location?.coordinates) {
      dataToUpdate.location = {
        type: "Point",
        coordinates: dataToUpdate.location.coordinates
      };
    }

    const now = new Date();
    const date = now.toLocaleDateString();
    const time = now.toLocaleTimeString();

    // 1️⃣ ALWAYS UPDATE RECOVERY DATA FIRST
    console.log("Updating recovery data...");
    await axios.put(
      `${apiUrl}recovery-update/${recoveryData.customerid}`,
      dataToUpdate
    );
    console.log("Recovery update success");

    // 2️⃣ ONLY UPDATE TASK IF COMING FROM TASK FLOW (hideButtons=true)
    if (hideButtons && taskId) {
      console.log("Updating task status to Completed...");
      await axios.put(
        `${apiUrl}update-task`,
        {
          id: taskId,
          updateData: {
            taskStatus: "Completed",
            taskUpdatedBy: {
              staffName,
              _id: Id,
              time,
              date
            }
          }
        }
      );
      console.log("Task status updated to Completed");
    }

     let colorCode = "#cccccc";
            switch (recoveryData.leadStatus) {
              case "Open":
                colorCode = "#fbdc6e";
                break;

                case "Progress":
                colorCode = "#cccccc";
                break;
              case "Not Available":
                colorCode = "#ffa5ee";
                break;
              case "Collected":
                colorCode = "#2c693a";
                break;
              case "Hold":
                colorCode = "#ffa770";
                break;
              case "Not Handover":
                colorCode = "#f07c7c";
                break;
              case "Out Of Station":
                colorCode = "#2e5caf";
                break;

                case "Expect Renewal":
                colorCode = "#663815";
                break;
            }
    
            // 📨 Add message (with optional image)
            const formData = new FormData();
            formData.append("pageRefId", recoveryData._id);
            formData.append("page", "Recovery");
            formData.append(
              "description",
            recoveryData.recoveryleadStatus?.recoverynotes || ""
            );
            if (selectedFile) formData.append("image", selectedFile);
            formData.append("updatesHistory[staff][name]", staffName);
            formData.append("updatesHistory[staff][id]", Id);
            formData.append("updatesHistory[status]", recoveryData.leadStatus);
            formData.append("colorCode", colorCode);
    
            try {
              await axios.post(apiUrl + "add-message", formData, {
                headers: { "Content-Type": "multipart/form-data" },
              });
    
              const res = await axios.get(`${apiUrl}messages/${pageRefId}`);
              setMessageData(res.data.data);
              setShowMessageBox(true);
            } catch (err) {
              console.warn("Message save failed, skipped showing error.");
            }

    // Success handling
    Swal.fire({ 
      title: "Success!", 
      text: hideButtons ? "Task completed & recovery updated" : "Recovery updated",
      icon: "success" 
    });

    // Reset edit mode
    setIsEditing(false);

    // If coming from task flow, optionally navigate away
    if (hideButtons) {
      // navigate("/some-path"); // Uncomment if needed
    }

  } catch (error) {
    console.error("Update failed:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.response?.data?.message || "Update operation failed",
    });
  }
};

  const toggleStaffDropdown = () => {
    setIsStaffDropdownOpen((prev) => !prev);
  };

  const toggleApproverDropdown = () => {
    setIsApproverDropdownOpen((prev) => !prev);
  };

  const handleStaffSelection = (staff) => {
    setSelectedStaff((prev) =>
      prev.some((s) => s._id === staff._id)
        ? prev.filter((s) => s._id !== staff._id)
        : [...prev, staff]
    );
  };

  // Handle approver selection
  const handleApproverSelection = (staff) => {
   setSelectedApprover((prev) =>
      prev.some((s) => s._id === staff._id)
        ? prev.filter((s) => s._id !== staff._id)
        : [...prev, staff]
    );
  };

  const getFutureDateTime = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 1); // add 1 minute to current time
  return now.toISOString().slice(0, 16); // returns 'YYYY-MM-DDTHH:MM'
};


  const getStaffDisplayText = () => {
    return selectedStaff.length > 0
      ? selectedStaff.map((staff) => staff.staffName).join(", ")
      : "Select staff";
  };

  const getApproverDisplayText =
    selectedApprover.length > 0
      ? selectedApprover.map((item) => item.staffName).join(", ")
      : "Select Approve Persons";

  // const handleTaskChange = (field, value) => {
  //   setTaskData((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  const formatDateTimeLocal = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};



useEffect(() => {
  if (taskData.assignDateTime) {
    const assignDate = new Date(taskData.assignDateTime);
    const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000); // +4 hours
    const formattedDeadline = formatDateTimeLocal(deadlineDate);

    setTaskData(prev => ({
      ...prev,
      deadline: formattedDeadline
    }));
  }
}, [taskData.assignDateTime]);





const handleTaskChange = (field, value) => {
  if (field === 'assignDateTime') {
    const assignDate = new Date(value);
    const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000);
    const formattedDeadline = deadlineDate.toISOString().slice(0, 16);

    setTaskData(prev => ({
      ...prev,
      assignDateTime: value,
      deadline: formattedDeadline // auto update
    }));
  } else {
    setTaskData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};




const handleSubmitWorkDetails = async () => {
  // When submitting from work details, we want to finalize the recovery
  setRecoveryData(prev => ({ ...prev, leadStatus: "Collected" }));
  
  // Wait a bit for state to update or pass the status directly if handleSaveClick supported it
  // For now, let's call handleSaveClick and we will modify it to use the latest state if needed
  // But setRecoveryData is async, so better to pass data or use a trick.
  // Actually, handleSaveClick uses recoveryData from state.
  
  setTimeout(async () => {
    await handleSaveClick();
  }, 100);
};

const handleSubmitAssignTask = async (e) => {
  e.preventDefault();

  if (selectedStaff.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "Incomplete Data",
      text: "Please select at least one staff member to assign",
    });
    return;
  }

  if (selectedApprover.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "Incomplete Data",
      text: "Please select an approver",
    });
    return;
  }

  Swal.fire({
    title: "Are you sure you want to create this task?",
    showCancelButton: true,
    confirmButtonText: "Submit",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, "0");
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const year = now.getFullYear();
        const updatedDate = `${day}-${month}-${year}`;

        const taskToSubmit = {
          ...taskData,
          assignedBy: {
            staffName: staffName,
            id: Id,
          },
          assignedTo: selectedStaff,
          approvePerson: selectedApprover,
          updatedDate,
          leadId: customerId,
          name: recoveryData?.customername || "",
          customerId: customerId,
          collectionId: recoveryData._id,
          activeTab: "orderDetails" // Add this line to explicitly set the active tab
        };

        const response = await axios.post(
          `${apiUrl}add-assign-task?page=${page}&tab=orderDetails`,
          taskToSubmit, // Changed from taskData to taskToSubmit
          { headers: { "Content-Type": "application/json" } }
        );

        Swal.fire({
          title: "Task Created Successfully!",
          icon: "success",
        }).then(() => {
          setIsOpenAssign(false);
          navigate("/task");
        });
      } catch (error) {
        console.error("Error submitting task:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.message || "Something went wrong!",
        });
      }
    }
  });
};
   const handleLocationChange = (newCoordinates) => {
    console.log("Updating location with:", newCoordinates);
    setCoordinates(newCoordinates);
    setRecoveryData(prev => ({
      ...prev,
      location: {
        type: "Point",
        coordinates: newCoordinates
      }
    }));
  };
  const renderContent = () => {
    if (!recoveryData) return <div>Loading...</div>;

    switch (activeTab) {
      case "orderDetails":
        return (
          // <RecoveryDetails
          //   recoveryData={recoveryData}
          //   customerId={customerId}
          //   isEditing={isEditing}
          //   onRecoveryChange={(field, value) => {
          //     setRecoveryData((prev) => ({ ...prev, [field]: value }));
          //   }}
          //   onNestedChange={(parentField, field, value) => {
          //     setRecoveryData((prev) => ({
          //       ...prev,
          //       [parentField]: {
          //         ...prev[parentField],
          //         [field]: value,
          //       },
          //     }));
          //   }}
          // />
  <RecoveryDetails
    recoveryData={recoveryData}
    selectedFile={selectedFile}
    setSelectedFile={setSelectedFile}
    customerId={customerId}
    isEditing={isEditing}
    onRecoveryChange={(field, value) => {
      setRecoveryData((prev) => ({ ...prev, [field]: value }));
    }}
    onNestedChange={(parentField, field, value) => {
      setRecoveryData((prev) => ({
        ...prev,
        [parentField]: {
          ...prev[parentField],
          [field]: value,
        },
      }));
    }}
    onLocationChange={handleLocationChange}
    handleSaveClick={handleSaveClick}
  />

        );
      case "workdetails":
        return (
          <WorkDetails recoveryData={recoveryData} customerId={customerId} />
        );
      default:
        return (
          <RecoveryDetails
            recoveryData={recoveryData}
            customerId={customerId}
          />
        );
    }
  };


     useEffect(() => {
      const fetchMessages = async () => {
        try {
          const response = await axios.get(`${apiUrl}messages/${pageRefId}`);
    
          if (response.status === 200 && Array.isArray(response.data.data)) {
            setMessageData(response.data.data); // ✅ Only the array!
          } else {
            console.error("Unexpected response structure:", response);
            setMessageData([]); // fallback to empty array
          }
        } catch (error) {
          console.error("Error fetching messages:", error);
          setMessageData([]); // fallback to empty array
        }
      }; 
    
      fetchMessages();
    }, [apiUrl, pageRefId]);
  return (
    <>
      <Topbar />
      <Container className="mt-1">
        <Row>
          <Col>
            <h3>Recovery</h3>
          </Col>
          <Col className="text-end me-5">
            {isOpenAssign && (
              <div className="overlay3">
                <div className="modal3">
                  <Container>
                    <div className="text-end mx-2">
                      <button
                        type="button"
                        className="black-btn mx-3"
                        onClick={() => setIsOpenAssign(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="blue-btn mx-3"
                        onClick={handleSubmitAssignTask}
                      >
                        Submit
                      </button>
                    </div>

                    <Row className="mt-4">
                      <Col xs={12} md={6}>
                        <Row>
                          <Col xs={12} md={6} className="text-start">
                            <label>Task Name</label>
                            <br />
                            <input
                              type="text"
                              className="form-input"
                              value={taskData.taskName}
                              readOnly
                            />
                          </Col>
                          <Col xs={12} md={6} className="text-start">
                            <label>Assign Date/Time</label>
                            <br />
                            <input
                              type="datetime-local"
                              className="form-input"
                                min={getFutureDateTime()} // optional: restrict past values

                              value={taskData.assignDateTime}
                              onChange={(e) =>
                                handleTaskChange(
                                  "assignDateTime",
                                  e.target.value
                                )
                              }
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <Row>
                          {/* <Col xs={12} md={6} className="text-start">
                            <label>Task Type</label>
                            <br />
                            <input
                              type="text"
                              value={taskData.taskType}
                              className="form-input"
                              onChange={(e) =>
                                handleTaskChange("taskType", e.target.value)
                              }
                            />
                          </Col> */}
                        
                          <Col xs={12} md={6} className="text-start">
                            <label>Task Priority</label>
                            <br />
                            <input
                              type="text"
                              value={taskData.taskPriority}
                              className="form-input"
                              onChange={(e) =>
                                handleTaskChange("taskPriority", e.target.value)
                              }
                            />
                          </Col>

                            <Col xs={12} md={6} className="text-start">
                            <label>Deadline Date/Time</label>
                            <br />
                            <input
                              type="datetime-local"
                                min={getFutureDateTime()} // only allows strictly future times

                              className="form-input overlay2"
                              value={taskData.deadline}
                              onChange={(e) =>
                                handleTaskChange("deadline", e.target.value)
                              }
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} md={6}>
                        <Row>
                           <Col xs={12} md={6} className="text-start">
                            <label>Customer ID</label>
                            <br />
                            <input
                              type="text"
                              className="form-input overlay2"
                              value={recoveryData?.customerid || ""}
                              readOnly
                            />
                          </Col>
                      
                        </Row>
                      </Col>
                      <Col>
                        <Row>
                        <Col xs={12} md={6} className="text-start mt-2">
  <label>Task Assign To</label>
  <br />
  <div
    ref={staffDropdownRef}
    style={{ position: "relative", width: "85%" }}
  >
    <div
      onClick={toggleStaffDropdown}
      style={{
        padding: "10px",
        border: "2px solid #a7a7a7",
        borderRadius: "4px",
        cursor: "pointer",
        backgroundColor: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "10px",
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {getStaffDisplayText()}
      </span>
      <span>{isStaffDropdownOpen ? "▲" : "▼"}</span>
    </div>

    {isStaffDropdownOpen && (
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          marginTop: "5px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          backgroundColor: "#fff",
          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
          zIndex: 1000,
          maxHeight: "200px",
          overflowY: "auto",
        }}
      >
        {staffData.length === 0 ? (
          <div
            style={{
              padding: "10px",
              color: "#888",
              textAlign: "center",
            }}
          >
            No staff found
          </div>
        ) : (
          staffData
            .filter((staff) =>
              ["Fiber Engineer", "Network Engineer", "Marketing/Fiber", "Marketing Executive"].includes(
                staff.designation
              )
            )
            .map((staff) => (
              <label
                key={staff._id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedStaff.some((s) => s._id === staff._id)}
                  onChange={() => handleStaffSelection(staff)}
                  style={{ marginRight: "10px" }}
                />
                {staff.staffName}
              </label>
            ))
        )}
      </div>
    )}
  </div>
</Col>

                          <Col xs={12} md={6} className="text-start mt-2">
                            <label>Approve Person</label>
                            <br />
                            <div
                              ref={approverDropdownRef}
                              style={{
                                position: "relative",
                                width: "85%",
                                marginTop: "15px",
                              }}
                            >
                              <div
                                onClick={toggleApproverDropdown}
                                style={{
                                  padding: "10px",
                                  border: "2px solid #a7a7a7",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  backgroundColor: "#fff",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginTop: "-5px",
                                }}
                              >
                                <span
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {getApproverDisplayText}
                                </span>
                                <span>
                                  {isApproverDropdownOpen ? "▲" : "▼"}
                                </span>
                              </div>

                              {isApproverDropdownOpen && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    right: 0,
                                    marginTop: "5px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                    zIndex: 1000,
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {staffNameFetch.length === 0 ? (
                                    <div
                                      style={{
                                        padding: "10px",
                                        color: "#888",
                                        textAlign: "center",
                                      }}
                                    >
                                      No staff found
                                    </div>
                                  ) : (
                                    staffNameFetch.map((staff) => (
                                      <label
                                        key={staff._id}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          padding: "10px",
                                          cursor: "pointer",
                                          borderBottom: "1px solid #eee",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          name="approver"
                                          checked={selectedApprover.some(
                                            (s) => s._id === staff._id
                                          )}
                                          onChange={() =>
                                            handleApproverSelection(staff)
                                          }
                                          style={{ marginRight: "10px" }}
                                        />
                                        {staff.staffName}
                                      </label>
                                    ))
                                  )}
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} md={6} className="text-start">
                        <label>Description</label>
                        <br />
                        <textarea
                          className="form-input inputfield-assign"
                          placeholder="Enter Notes"
                          value={taskData.description}
                          onChange={(e) =>
                            handleTaskChange("description", e.target.value)
                          }
                          style={{
                            textTransform: "capitalize",
                            resize: "none",
                          }}
                        />
                      </Col>
                      <Col>
                        <Row>
                         {/* customer name */}
                          <Col xs={12} md={6} className="text-start">
                            <label>Customer Name</label>
                            <br />
                            <input
                              type="text"
                              className="form-input"
                              value={recoveryData?.customername || ""}
                              readOnly
                              style={{ textTransform: "capitalize" }}
                            />
                          </Col>
                            <Col xs={12} md={6} className="text-start">
                            <label>Task Status</label>
                            <br />
                            <input
                              type="text"
                              className="form-input"
                              value={taskData.taskStatus}
                              readOnly
                              style={{ textTransform: "capitalize", backgroundColor: "#fbdc6e",
                        color: "rgb(94, 94, 14)", }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          {/* //open status */}
                        
                        </Row>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            )}
        

{/* Conditional rendering based on active tab and edit mode */}
{activeTab === "orderDetails" && !isEditing && (
  <>
    {!hideButtons ? (
      <>
        <button
          className="black-btn mx-1 mt-1"
          type="button"
          onClick={handleEditClick}
        >
          <MdEdit className="mx-1 editicon-recovery" />
          Edit
        </button>
        {recoveryData?.leadStatus !== "Collected" && (
          <button
            className="blue-btn my-1 ms-1"
            type="button"
            onClick={handleOpenAssign}
          >
            <MdOutlineAssignmentInd className="mx-1 editicon-recovery" />
            Assign
          </button>
        )}
      </>
    ) : (
      <button
        className="black-btn mx-1 mt-1"
        type="button"
        onClick={handleEditClick}
      >
        <MdEdit className="mx-1 editicon-recovery" />
        Update
      </button>
    )}
  </>
)}


{activeTab === "orderDetails" && isEditing && (
  <>
    <button
      className="blue-btn my-1"
      type="button"
      onClick={handleSaveClick}
    > 
      Save
    </button>
    <button
      className="black-btn my-1 ms-1"
      type="button"
      onClick={handleCancelClick}
    >
      Cancel
    </button>
  </>
)}

{/* Only show Submit button in Work Details */}
{activeTab === "workdetails" && (
  <button
    className="blue-btn my-1"
    type="button"
    onClick={handleSubmitWorkDetails}
  >
    Submit
  </button>
)}
           
          </Col>
        </Row>

        <div className="tabs-container mt-5 mb-4">
          <div className="tabs">
            <Row>
              <Col>
                <button
                  type="button"
                  className={`tab-button ${
                    activeTab === "orderDetails" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("orderDetails")}
                >
                  Order Details
                </button>
              </Col>
              <Col>
                <button
                  type="button"
                  className={`tab-button ${
                    activeTab === "workdetails" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("workdetails")}
                >
                  Work Details
                </button>
              </Col>
            </Row>
          </div>

          <div className="tab-content">{renderContent()}</div>
        </div>

           {/* {showMessageBox && ( */}
                      <Row className="container ms-3 me-5">
                  <Col md={6} sm={12}> 
                    <div>
                      {Array.isArray(messageData) && messageData.length > 0 ? (
                        messageData.map((msg) => (
                          <MessageBox key={msg._id} message={msg} />
                        ))
                      ) : (
                        <div className="text-muted">No messages available.</div>
                      )}
                    </div>
                  </Col>
                
                  <Col md={6} sm={12}>
                    <div className="compact-updates-history">
                      <div className="compact-updates-header">Updates History</div>
                      {Array.isArray(messageData) && messageData.length > 0 ? (
                        messageData.map((data, index) => (
                          <div className="compact-update text-center" key={index}>
                            <div className="compact-update-date text-center">
                              {data.updatesHistory.date ? (
                                new Date(data.updatesHistory.date).toLocaleDateString("en-GB") +
                                " - " +
                                new Date(data.updatesHistory.date)
                                  .toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })
                              ) : (
                                "No date"
                              )}
                            </div>
                
                            <div className="compact-update-user text-center">
                              {data.updatesHistory?.staff?.name || "Unknown"}
                            </div>
                
                            <div
                              className="compact-update-status text-center"
                              style={{ color: data.colorCode || "#000000" }}
                            >
                              {data.updatesHistory?.status || "No Status"}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-muted text-center">No update history available.</div>
                      )}
                    </div>
                  </Col>
                </Row>
      </Container>
    </>
  );
};

export default ViewRecovery;